import {
    MeBookingTripDocument,
    MeBookingTripFragment,
    MeBookingTripQuery,
    MeBookingTripQueryVariables,
    MyAccountBasicMyTripFragment,
} from "generated/graphql";

import { useSuspenseQuery } from "@apollo/client";
import { useLightMe } from "./use-light-me";

// TODO: Broken apart to turn into a specific query for the Checklist Page. WWB-990
export const useBookingTripForChecklist = (
    tripId: string,
): MeBookingTripFragment | null | undefined => {
    const { data } = useSuspenseQuery<
        MeBookingTripQuery,
        MeBookingTripQueryVariables
    >(MeBookingTripDocument, {
        variables: {
            tripId,
        },
    });
    return data.bookingTrip;
};

// This hook is used under the assumption that the `LightMe` query will always have been run and will be cached because it is used for the navigation.
export const useMyTripForBookingId = (
    bookingId?: string,
): MyAccountBasicMyTripFragment | null | undefined => {
    const { customer } = useLightMe();
    if (!customer) {
        return null;
    }

    const { confirmedTrips, requestedTrips, pendingRebookingTrips } = customer;
    return (
        confirmedTrips.find((trip) => trip.booking?._id === bookingId) ??
        requestedTrips.find((trip) => trip.booking?._id === bookingId) ??
        pendingRebookingTrips.find((trip) => trip.booking?._id === bookingId)
    );
};

// I made this a specific hook so that if we decide to refactor this specific use case later we can.
export const useTripIdForBookingId = (bookingId?: string) =>
    useMyTripForBookingId(bookingId)?._id;
